import store from "../store";
import Constants from "../config/constants";
import EventEmitter from "../libs/Events.utils";
import {
  serviceFeedbackList,
  serviceFeedbackDetail,
  serviceFeedbackResendMessage,
  serviceFeedbackCustomerDetail,
  serviceFeedbackCustomerSubmit,
} from "../services/Feedback.service";

export const FETCH_INIT = "FETCH_INIT_FEEDBACK";
export const FETCHED = "FETCHED_FEEDBACK";
export const FETCHED_FAIL = "FETCHED_FAIL_FEEDBACK";
export const SET_FILTER = "SET_FILTER_FEEDBACK";
export const SET_SORTING = "SET_SORTING_FEEDBACK";
export const CHANGE_PAGE = "CHANGE_PAGE_FEEDBACK";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_FEEDBACK";
export const RESET_LIST = "RESET_LIST_FEEDBACK";
export const UPDATE_ITEM = "UPDATE_ITEM_FEEDBACK";

export function actionFetchFeedback(index = 1, sorting = {}, filter = {}) {
  const request = serviceFeedbackList({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((response) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!response?.error) {
        const payloadData = response?.data || {};
        const tableData = payloadData?.data || payloadData?.results || [];
        const total =
          payloadData?.meta?.total ??
          payloadData?.total ??
          payloadData?.count ??
          payloadData?.pagination?.total ??
          tableData.length ??
          0;
        dispatch({
          type: FETCHED,
          payload: {
            data: tableData,
            page: index,
            total,
          },
        });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index === 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionResetFeedbackList() {
  return {
    type: RESET_LIST,
    payload: null,
  };
}

export function actionSetPageFeedbackRequests(page) {
  const stateData = store.getState().feedback;
  const currentPage = stateData?.currentPage || 0;
  const totalLength = stateData?.all?.length || 0;
  const sortingData = stateData?.sorting_data || {};
  const query = stateData?.query;
  const queryData = stateData?.query_data;
  const serverPage = stateData?.serverPage || 0;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchFeedback(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}

export function actionFeedbackResendMessage(params) {
  const request = serviceFeedbackResendMessage(params);
  return () => {
    return request.then((response) => {
      if (!response?.error) {
        EventEmitter.dispatch(EventEmitter.THROW_ERROR, {
          error: response?.data?.message || "Message resent successfully",
          type: "success",
        });
      }
      return response;
    });
  };
}

export function actionFeedbackDetail(params) {
  const request = serviceFeedbackDetail(params);
  return () => request;
}

export function actionFeedbackCustomerDetail(params) {
  const request = serviceFeedbackCustomerDetail(params);
  return () => request;
}

export function actionFeedbackCustomerSubmit(params) {
  const request = serviceFeedbackCustomerSubmit(params);
  return () => request;
}

